<template>
  <div>
    <card v-if="isAdmin || isLvl1User">
      <form @submit.prevent>
        <div class="form-row">
          <base-input class="col-md-3" placeholder="User">
              <select v-model="selectedUser" @change="onUserSelect()" id="inputState" class="form-control">
                <option :value="{}" disabled>{{ $t('commons.userSelectPlaceholder')}}</option>
                <option
                  v-for="(user) in users"
                  :value="user"
                  :key="user.email"
                >{{user.username}}</option>
              </select>
            </base-input>
        </div>
      </form>
    </card>
    <div class="row">
      <div v-for="(cbData, index) in bmsData" :key="index" class="col-lg-6 col-md-6">
        <!-- Add a function in card sass like the one for the button, use a selector like card-border-$primary where $primary can be any of the ones defined in config -->
        <div v-bind:class="cbData | computeBMSCardCssClass" >
            <div class="card-body bms-card-body">

              <div class="bms-content-wrapper">
                <div class="row no-gutters">

                  <div class="col-6">
                    <div class="text-center bms-text-section">
                      <p class="card-category">Bms</p>
                      <h1 class="card-text bms-title">{{cbData.bms ? (cbData.alias || cbData.bms) : "-"}}</h1>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="text-center bms-text-section">
                        <p class="card-category">{{$t('rechargeRoom.workingTime')}}</p>
                        <h1 class="card-text">{{formatMinutes(cbData.forkDuration)}}</h1>
                    </div>
                  </div>

                </div>

                <div class="row no-gutters">

                  <div class="col-6">
                    <div class="text-center bms-text-section">
                      <p class="card-category">{{$t('rechargeRoom.lastSeen')}}</p>
                      <h1 class="card-text last-seen-text" v-html="addLineBreaksToLastSeen(cbData)"></h1>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="text-center bms-text-section">
                        <p class="card-category">{{$t('rechargeRoom.batteryStatus')}}</p>
                        <h1 class="card-text">
                          <svg-icon v-if="(cbData.current && cbData.current < -2)" type="mdi" :path="forkliftIconPath" style="height: 42px; width: auto;"></svg-icon>
                          <i v-else-if="(cbData.current && cbData.current > 2)" class="fas fa-regular fa-charging-station"></i>
                          <i v-else-if="(typeof cbData.current !== 'undefined')" class="fas fa-solid fa-square-parking"></i>
                          {{cbData | computeBMSstatus}}
                          <i v-if="(cbData.bms && cbData.bmsError) || (cbData.cbError && !cbData.bms)" class="fas fa-droplet-slash" style="color: red;"></i>
                        </h1>

                    </div>
                  </div>

                </div>
              </div>

              <div class="bms-gps-button">
                <button
                  v-if="cbData.latitude && cbData.longitude && !isNaN(parseFloat(cbData.latitude)) && !isNaN(parseFloat(cbData.longitude))"
                  @click="showMapModal(cbData)"
                  class="gps-btn"
                  :title="'Mostra posizione GPS'"
                >
                  <i class="fa-solid fa-location-dot"></i>
                </button>
                <button
                  v-else
                  class="gps-btn gps-btn-disabled"
                  :title="'GPS non disponibile'"
                  disabled
                >
                  <i class="fa-solid fa-xmark" style="color: #f5365c;"></i>
                </button>
                <small class="gps-label">GPS</small>
              </div>

            </div>
        </div>
      </div>

    </div>

    <!-- Modale GPS -->
    <modal
      :show.sync="showGpsModal"
      @close="closeMapModal"
      modal-classes="gps-modal-fullscreen"
      :show-close="false"
    >
      <template slot="header">
        <h4 class="modal-title">{{$t('gps.modalTitle')}} - {{selectedBmsData.alias || selectedBmsData.bms || 'N/A'}}</h4>
        <button
          type="button"
          class="close"
          @click="closeMapModal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>

      <template slot="default">
        <!-- Contenitore con flex per date range e mappa -->
        <div style="height: 100%; width: 100%; display: flex; flex-direction: column;">

          <!-- Row con filtri date -->
          <div class="gps-filters-row">
            <div class="row">
              <div class="col-md-3 col-sm-6 gps-date-input">
                <vc-date-picker
                  v-model="gpsDateRange.start"
                  mode="dateTime"
                  :color="calendarColor"
                  :is-dark="!whiteTheme"
                  locale="en-GB"
                  is24hr
                  :max-date="new Date()"
                  :popover="{ visibility: 'click' }"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <date-input
                      addon-left-icon="tim-icons icon-calendar-60"
                      placeholder="from"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </vc-date-picker>
              </div>

              <div class="col-md-3 col-sm-6 gps-date-input">
                <vc-date-picker
                  v-model="gpsDateRange.end"
                  mode="dateTime"
                  :color="calendarColor"
                  :is-dark="!whiteTheme"
                  locale="en-GB"
                  is24hr
                  :min-date="gpsDateRange.start"
                  :max-date="new Date()"
                  :popover="{ visibility: 'click' }"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <date-input
                      addon-left-icon="tim-icons icon-calendar-60"
                      placeholder="to"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </vc-date-picker>
              </div>

              <div class="col-md-3 col-sm-6 gps-date-button">
                <base-button
                  :disabled="!canQueryGpsData || isLoadingGpsData"
                  @click="loadGpsData"
                  type="primary-nogradient"
                  size="sm"
                >
                  <i v-if="isLoadingGpsData" class="fas fa-spinner fa-spin"></i>
                  {{isLoadingGpsData ? 'Caricamento...' : $t('gps.historicalButton')}}
                </base-button>
              </div>

              <div class="col-md-3 col-sm-6 gps-date-button">
                <base-button
                  :disabled="!hasValidGpsData || isLoadingGpsData"
                  @click="showLastPositionOnly"
                  type="primary-nogradient"
                  size="sm"
                >
                  <i v-if="isLoadingGpsData" class="fas fa-spinner fa-spin"></i>
                  {{$t('gps.lastPositionButton')}}
                </base-button>
              </div>
            </div>
          </div>

          <!-- Mappa GPS Leaflet -->
          <div style="flex: 1; min-height: 0; width: 100%">
            <l-map
              v-if="showGpsModal"
              :zoom="mapZoom"
              :center="mapCenter"
              :options="mapOptions"
              style="height: 100%; width: 100%"
              @update:center="centerUpdate"
              @update:zoom="zoomUpdate"
            >
              <l-tile-layer
                :url="mapUrl"
                :attribution="mapAttribution"
              />

              <!-- Polyline per mostrare la scia delle posizioni storiche -->
              <l-polyline
                v-if="gpsTrailPath.length > 1"
                :lat-lngs="gpsTrailPath"
                :color="'#007bff'"
                :weight="3"
                :opacity="0.7"
              ></l-polyline>

              <!-- Marker per ultima posizione quando c'è un time range selezionato -->
              <l-marker v-if="shouldShowLastPositionMarker" :lat-lng="lastPositionLocation">
                <l-popup>
                  <div>
                    <h5>{{selectedBmsData.alias || selectedBmsData.bms || 'BMS'}}</h5>
                    <p><strong>{{$t('gps.bmsId')}}</strong> {{selectedBmsData.bms || 'N/A'}}</p>
                    <p><strong>{{$t('gps.batteryStatus')}}</strong> {{selectedBmsData | computeBMSstatus}}</p>
                    <p><strong>{{$t('gps.lastPosition')}}</strong> {{lastPositionTime}}</p>
                    <p><strong>{{$t('gps.coordinates')}}</strong><br>
                       {{$t('gps.latitude')}} {{lastPositionLocation.lat}}<br>
                       {{$t('gps.longitude')}} {{lastPositionLocation.lng}}
                    </p>
                  </div>
                </l-popup>
              </l-marker>
            </l-map>

            <!-- Fallback se non ci sono dati GPS -->
            <div v-if="!shouldShowLastPositionMarker" style="height: 100%; background-color: #f8f9fa; display: flex; align-items: center; justify-content: center; border: 1px solid #dee2e6;">
              <div class="text-center">
                <i class="fa-solid fa-location-slash" style="font-size: 48px; color: #6c757d; margin-bottom: 20px;"></i>
                <h4 class="text-muted">{{$t('gps.noDataTitle')}}</h4>
                <p class="text-muted">{{$t('gps.bmsId')}} {{selectedBmsData.bms || 'N/A'}}</p>
                <small class="text-muted">{{$t('gps.noDataMessage')}}</small>
              </div>
            </div>
          </div>
        </div>
      </template>
    </modal>

  </div>
</template>
<script>
import { mapState } from 'vuex'
const iconsContext = require.context('@/assets/icons/', true, /\.svg$/);
import {InfluxDB, FluxTableMetaData} from '@influxdata/influxdb-client'
import {url, token, org, presenceLookbackTime} from '@/config/env'
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiForklift } from '@mdi/js'
import Modal from '@/components/Modal'
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LPolyline } from "vue2-leaflet";

// Fix per le icone Leaflet
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

let queryApi = {}

const fluxQuery = `from(bucket: "test")
                    |> range(start: -${presenceLookbackTime})
                    |> filter(fn: (r) => r["_measurement"] == "tl")
                    |> filter(fn: (r) => r["_field"] == "IP")
                    |> group(columns: ["origin"])
                    |> top(n:1, columns: ["_time"])
                    |> yield()`

export default {
  components: {
    SvgIcon,
    Modal,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LPolyline
  },
  data() {
    return {
      batteryIconSrc: iconsContext('./batteryAlt.svg'),
      chargerIconSrc: iconsContext('./chargerAlt.svg'),
      selectedUser: {},
      cbsList: [],
      // A map would be ideal but maps are not currently supported by v-for https://github.com/vuejs/vue/issues/6644
      cbsData: [],
      // New fields to replace cbs
      bmsList:[],
      bmsData: [],
      forkliftIconPath: mdiForklift,
      // GPS Modal properties
      showGpsModal: false,
      selectedBmsData: {},
      // GPS Date range
      gpsDateRange: {
        start: new Date((new Date((new Date).setHours(0))).setMinutes(0)),
        end: new Date((new Date((new Date).setHours(23))).setMinutes(59)),
      },
      // Map properties
      mapZoom: 13,
      mapCenter: latLng(45.0422222, 9.75361111), // Coordinate di default per la mappa
      currentZoom: 13,
      currentCenter: latLng(45.0422222, 9.75361111),
      mapUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      mapAttribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      mapOptions: {
        zoomSnap: 0.5
      },
      // GPS Historical positions
      gpsHistoricalPositions: [],
      isLoadingGpsData: false
    };
  },
  computed: {
    ...mapState([
      'logged',
      'loggedUserEmail',
      'isAdmin',
      'isLvl1User',
      'whiteTheme',
      'calendarColor',
      'users',
      'bmss'
    ]),
    hasValidGpsData() {
      // Check if the selected BMS has valid GPS coordinates
      return this.selectedBmsData &&
             this.selectedBmsData.latitude &&
             this.selectedBmsData.longitude &&
             !isNaN(parseFloat(this.selectedBmsData.latitude)) &&
             !isNaN(parseFloat(this.selectedBmsData.longitude));
    },
    bmsLocation() {
      if (this.hasValidGpsData) {
        return latLng(
          parseFloat(this.selectedBmsData.latitude),
          parseFloat(this.selectedBmsData.longitude)
        );
      }
      return this.mapCenter;
    },
    canQueryGpsData() {
      return this.selectedBmsData &&
             this.selectedBmsData.bms &&
             this.gpsDateRange.start &&
             this.gpsDateRange.end &&
             !this.dateEquals(this.gpsDateRange.start, this.gpsDateRange.end);
    },
    gpsTrailPath() {
      // Mostra solo la scia delle posizioni storiche (senza l'ultima posizione assoluta)
      return this.gpsHistoricalPositions.map(p => [p.lat, p.lng]);
    },
    shouldShowLastPositionMarker() {
      // Mostra sempre il marker dell'ultima posizione se ci sono dati validi
      // Se ci sono posizioni storiche caricate (time range selezionato),
      // l'ultima posizione sarà quella recuperata dalla query con "last"
      // Altrimenti sarà l'ultima posizione assoluta del BMS
      if (this.gpsHistoricalPositions.length > 0) {
        // C'è un time range selezionato, quindi c'è un'ultima posizione da mostrare
        return true;
      }

      // Nessun time range selezionato, mostra l'ultima posizione assoluta
      return this.hasValidGpsData;
    },
    lastPositionLocation() {
      // Se ci sono posizioni storiche, l'ultima è quella da mostrare
      if (this.gpsHistoricalPositions.length > 0) {
        const lastPos = this.gpsHistoricalPositions[this.gpsHistoricalPositions.length - 1];
        return latLng(lastPos.lat, lastPos.lng);
      }

      // Altrimenti usa l'ultima posizione assoluta del BMS
      return this.bmsLocation;
    },
    lastPositionTime() {
      // Se ci sono posizioni storiche, usa il timestamp dell'ultima
      if (this.gpsHistoricalPositions.length > 0) {
        const lastPos = this.gpsHistoricalPositions[this.gpsHistoricalPositions.length - 1];
        return this.formatDate(lastPos.time);
      }

      // Altrimenti usa il timestamp dell'ultima posizione assoluta del BMS
      return this.$options.filters.computeLastPositionDate(this.selectedBmsData);
    }
  },
  watch: {
    whiteTheme(newValue, oldValue) {
      this.toggleImages()
    },
    users(newValue, oldValue) {
      this.loadUser()
    },
    bmss(newValue, oldValue) {
      this.loadUser()
    }
  },
  filters: {
    computeBMSstatus(cbData) {
      //console.log("Computing bms status")
      //console.log(cbData)
      if(cbData.bms) {
        if(!cbData.charge) return "-"
        var status = cbData.charge + "%"
        if(cbData.bmsError) {
          /*
          var errCode = cbData.bmsError >> 7
          if(errCode == 1) {
            status += " Refill"
          }
          */
          if(cbData.bmsError)
            status += " Refill"
        }
        return status
      }
     /*
      else if (cbData.cbError) {
        const errCode = cbData.cbError
        if(errCode == 1)
          return "CAN error"
        else if(errCode == 2)
          return "AUX error"
        else if(errCode == 3)
          return "CAN & AUX error"
        else if(errCode == 4)
          return "PWR error"
        else if(errCode == 5)
          return "PWR, CAN error"
        else if(errCode == 6)
          return "PWR, AUX error"
        else
          return "Error"
      }
      */
      else
        return "-"
    },
    computeLastSeen(cbData) {
      if (!cbData || !cbData.lastSeen) return '-'
      try {
        const newDate = new Date(cbData.lastSeen)
        return newDate.toLocaleString()
      } catch (e) {
        return '-'
      }
    },
    computeLastPositionDate(cbData) {
      if (!cbData || !cbData.gpsLastSeen) return '-'
      try {
        const newDate = new Date(cbData.gpsLastSeen)
        return newDate.toLocaleString()
      } catch (e) {
        return '-'
      }
    },
    computeBMSCardCssClass(cbData) {
      if(!cbData.bms || !cbData.charge)
        return ['card', 'card-stats', 'disconnected']
      if(cbData.charge < 80)
        return ['card', 'card-stats', 'not-charged']
      if(cbData.charge < 100)
        return ['card', 'card-stats', 'half-charged']
      else
        return ['card', 'card-stats', 'charged']
    },
    addLineBreaks(text) {
      if (!text) return text;
      // Inserisce <wbr> (Word Break Opportunity) dopo : e / per controllare l'interruzione di riga
      return text.replace(/([:/])/g, '$1<wbr>');
    }
  },
  methods: {
    formatDate(value) {
      if (!value) return '-'
      try {
        const newDate = new Date(value)
        return newDate.toLocaleString()
      } catch (e) {
        return '-'
      }
    },
    loadUser() {
      if(this.selectedUser && this.users && this.users.length > 0 && !this.isAdmin) {
        this.selectedUser = this.users[0]
        this.onUserSelect();
      }
    },
    onUserSelect() {
      //console.log('User selected ', this.selectedUser);
      this.bmsList = this.selectedUser.bmsList || [];
      this.queryApi = new InfluxDB({url, token: this.getToken()}).getQueryApi(org)
      //console.log('InfluxDB client instance recreated with token ', this.getToken())
      //console.log(this.queryApi)
      //this.getBmsStatuses()
      this.getBmsData()
    },
    getBucket() {
      return this.selectedUser.bucket || '';
    },
    getToken() {
      return this.selectedUser.token || '';
    },
    addLineBreaksToLastSeen(cbData) {
      // Prima applica il filtro computeLastSeen
      let lastSeenText = this.$options.filters.computeLastSeen(cbData);
      // Poi applica le interruzioni di riga
      if (!lastSeenText || lastSeenText === '-') return lastSeenText;
      return lastSeenText.replace(/([:/])/g, '$1<wbr>');
    },
    toggleImages() {
      if(this.whiteTheme) {
        this.batteryIconSrc = iconsContext('./battery.svg');
        this.chargerIconSrc = iconsContext('./charger.svg');
      } else{
        this.batteryIconSrc = iconsContext('./batteryAlt.svg');
        this.chargerIconSrc = iconsContext('./chargerAlt.svg');
      }
    },
    formatRemainingChargeTime(minutesCharged, fullChargeInMinutes) {
      var remainingTime = fullChargeInMinutes - minutesCharged
      if(remainingTime < 0) remainingTime = 0
      return this.formatMinutes(remainingTime)
    },
    formatMinutes(minutes) {
      if(!minutes || minutes < 0) minutes = 0
      return Math.trunc(minutes/60) + 'h '  + (minutes % 60) + 'm'
    },
    computeChargeTime(cbData) {
      if(!cbData.bms) return "-"
      if(!cbData.charge) return "-"
      if(cbData.charge && cbData.charge == 100) return this.formatMinutes(0)
      if(!cbData.minutesRecharged) return "-"
      return this.formatRemainingChargeTime(cbData.minutesRecharged, cbData.hoursToRecharge*60)
    },
    getBmsStatuses() {
      console.log("Fetch bms statuses")

      if(!this.selectedUser) {
        return;
      }
      var outerScope = this
      var promises = []

      if(this.bmsList) {
        this.bmsList.forEach(e => {
          //console.log(`Telemetry for cb: ${e.cbs}`)
          promises.push(outerScope.getBmsStatusPromise(e))
        })

        Promise.allSettled(promises).then((results) => {
          const resolved = results.filter(r => r.status === "fulfilled");
          const values = resolved.map(r => r.value)
          //values.sort( (a, b) => a.cbs.localeCompare(b.cbs));
          outerScope.bmsData = values
          console.log(outerScope.bmsData)
        });
      }

    },
    getBmsStatusPromise(bmsId) {
      const vueScope = this;
      return new Promise((resolve, reject) => {
        const outerScope = {resolve, reject}
        const bmsStatusQuery = `from(bucket: "${vueScope.getBucket()}")
                                |> range(start: -10d)
                                |> filter(fn: (r) => r["_measurement"] == "tl")
                                |> filter(fn: (r) => r.bm == "${bmsId}")
                                |> group(columns: ["_field"])
                                |> top(n:1, columns: ["_time"])`;
        //console.log("Query")
        console.log(bmsStatusQuery)
        let bmsDataElement = this.bmss.find(bms => bms.bms_id == bmsId)
        bmsDataElement.bms = bmsDataElement.bms_id

        //console.log("Query Api")
        //console.log(vueScope.queryApi)
        vueScope.queryApi.queryRows(bmsStatusQuery, {
          next(row, tableMeta) {
            const o = tableMeta.toObject(row)
            if(o._field == "ch") bmsDataElement.charge = o._value
            if(o._field == "ct") bmsDataElement.chargeTime = o._value
            if(o._field == "e1") bmsDataElement.bmsError = o._value
            if(o._time) bmsDataElement.lastSeen = o._time
          },
          error(error) {
            console.log(`${bmsId} DATA FETCH ERROR`)
            console.error(error)
            outerScope.reject(new Error(error))
          },
          complete() {
            //console.log(`${bmsId} DATA FETCH SUCCESS`)
            //console.log(`Telemetry for cb: ${cbsListElement.cbs}`)
            console.log(`${bmsId} DATA FETCH SUCCESS`)
            console.log(bmsDataElement)
            outerScope.resolve(bmsDataElement)
          },
        })
      });
    },
    getBmsData() {
      if(!this.selectedUser || !this.bmsList || !this.bmss || this.bmsList.length === 0 || this.bmss.length === 0) {
        this.bmsData = {}
        return;
      }
      var outerScope = this
      var query = this.buildQuery(this.bmsList)
      var bmsData = {}
      this.bmsList.forEach(bmsId => {
        var obj = this.bmss.find(bms => bms.bms_id == bmsId)
        obj.bms = bmsId
        bmsData[bmsId] = obj
      })

      this.queryApi.queryRows(query, {
        next(row, tableMeta) {
          const o = tableMeta.toObject(row)
          var resultFields = o.result.split('_')
          var table = resultFields[0]
          var bmsId = resultFields[1]
          if(table == 'totalForkDuration') {
            bmsData[bmsId].forkDuration = o.forkDuration
          } else {
            if(o._field == "ch") bmsData[bmsId].charge = o._value
            if(o._field == "ct") bmsData[bmsId].chargeTime = o._value
            if(o._field == "cu") bmsData[bmsId].current = o._value
            if(o._field == "e1") bmsData[bmsId].bmsError = o._value
            if(o._field == "la") {
              bmsData[bmsId].latitude = o._value
              bmsData[bmsId].gpsLastSeen = o._time
            }
            if(o._field == "lo") bmsData[bmsId].longitude = o._value
            if(o._time) bmsData[bmsId].lastSeen = o._time
          }
        },
        error(error) {
          console.log(`DATA FETCH ERROR`)
          console.error(error)
        },
        complete() {
          console.log(`DATA FETCH SUCCESS`)
          console.log(bmsData)
          outerScope.bmsData = bmsData
        },
      })
    },
    buildSingleBmsQuery(bucket, bmsId) {
      const bmsStatusQuery = `statusData_${bmsId} = from(bucket: "${bucket}")
          |> range(start: -10d)
          |> filter(fn: (r) => r["_measurement"] == "tl")
          |> filter(fn: (r) => r.bm == "${bmsId}")
          |> group(columns: ["_field"])
          |> top(n:1, columns: ["_time"])
          |> yield(name: "statusData_${bmsId}")

        cyclesData_${bmsId} = from(bucket: "${bucket}")
          |> range(start: -10y)
          |> filter(fn: (r) => r["_measurement"] == "tl")
          |> filter(fn: (r) => r.bm == "${bmsId}")
          |> filter(fn: (r) => r["_field"] == "ft")
          |> filter(fn: (r) => exists r.nu)
          |> group(columns: ["bm", "nu"])

        minForkTime_${bmsId} = cyclesData_${bmsId}
          |> min()
        maxForkTime_${bmsId} = cyclesData_${bmsId}
          |> max()

        forkDurations_${bmsId} = join(tables: {minFt: minForkTime_${bmsId}, maxFt: maxForkTime_${bmsId}}, on: ["_start", "_stop", "bm", "nu", "_field", "_measurement"], method: "inner")
          |> map(fn: (r) => ({ r with forkDuration: int(v: r._value_maxFt) - int(v: r._value_minFt) }))
          |> group()

        totalForkDuration_${bmsId} = forkDurations_${bmsId}
          |> sum(column: "forkDuration")
          |> yield(name: "totalForkDuration_${bmsId}")`;
      return bmsStatusQuery;
    },
    buildQuery(bmsIdList) {
      return bmsIdList.map(bmsId => this.buildSingleBmsQuery(this.getBucket(), bmsId)).join('\n');
    },
    showMapModal(cbData) {
      console.log('Mostrare mappa per:', cbData);
      this.selectedBmsData = cbData;

      // Se ci sono dati GPS validi, centra la mappa su di essi
      if (cbData && cbData.latitude && cbData.longitude) {
        const lat = parseFloat(cbData.latitude);
        const lng = parseFloat(cbData.longitude);
        if (!isNaN(lat) && !isNaN(lng)) {
          this.mapCenter = latLng(lat, lng);
          this.currentCenter = latLng(lat, lng);
          this.mapZoom = 15; // Zoom più ravvicinato per vedere i dettagli
          this.currentZoom = 15;
        }
      }

      this.showGpsModal = true;
    },
    closeMapModal() {
      this.showGpsModal = false;
      this.selectedBmsData = {};
      // Reset map to default position
      this.mapCenter = latLng(45.0422222, 9.75361111);
      this.currentCenter = latLng(45.0422222, 9.75361111);
      this.mapZoom = 13;
      this.currentZoom = 13;
      // Reset date range
      this.gpsDateRange = {
        start: new Date((new Date((new Date).setHours(0))).setMinutes(0)),
        end: new Date((new Date((new Date).setHours(23))).setMinutes(59)),
      };
      // Reset historical positions
      this.gpsHistoricalPositions = [];
      this.isLoadingGpsData = false;
    },
    showLastPositionOnly() {
      // Reset delle posizioni storiche per mostrare solo l'ultima posizione assoluta
      this.gpsHistoricalPositions = [];

      // Centra la mappa sull'ultima posizione del BMS
      if (this.hasValidGpsData) {
        const lat = parseFloat(this.selectedBmsData.latitude);
        const lng = parseFloat(this.selectedBmsData.longitude);
        if (!isNaN(lat) && !isNaN(lng)) {
          this.mapCenter = latLng(lat, lng);
          this.currentCenter = latLng(lat, lng);
          this.mapZoom = 15;
          this.currentZoom = 15;
        }

        this.$notify({
          type: 'success',
          message: this.$t('gps.showingLastPosition'),
          icon: 'tim-icons icon-pin',
        });
      }
    },
    dateEquals(a, b) {
      // https://stackoverflow.com/questions/4587060/determining-date-equality-in-javascript
      return (a >= b && a <= b);
    },
    loadGpsData() {
      if (!this.canQueryGpsData) {
        return;
      }

      this.isLoadingGpsData = true;
      this.gpsHistoricalPositions = [];

      const bmsId = this.selectedBmsData.bms;
      const numPositions = 100; // Numero di posizioni intermedie da recuperare

      // Calcolo della durata del range in millisecondi
      const rangeStart = this.gpsDateRange.start.toISOString();
      const rangeEnd = this.gpsDateRange.end.toISOString();
      const rangeDuration = this.gpsDateRange.end.getTime() - this.gpsDateRange.start.getTime();
      const windowDuration = Math.floor(rangeDuration / numPositions);

      console.log('Caricamento dati GPS per il range:', this.gpsDateRange);
      console.log('BMS:', bmsId);
      console.log('Window duration:', windowDuration, 'ms');

      const outerScope = this;

      // Query InfluxDB per ottenere posizioni GPS equidistribuite nel range
      // Utilizziamo aggregateWindow con fn: last per ottenere l'ultima posizione di ogni finestra
      // In questo modo l'ultima posizione recuperata sarà effettivamente l'ultima nel time range
      const gpsQuery = `from(bucket: "${this.getBucket()}")
        |> range(start: ${rangeStart}, stop: ${rangeEnd})
        |> filter(fn: (r) => r["_measurement"] == "tl")
        |> filter(fn: (r) => r.bm == "${bmsId}")
        |> filter(fn: (r) => r["_field"] == "la" or r["_field"] == "lo")
        |> aggregateWindow(every: ${Math.floor(windowDuration / 1000)}s, fn: last, createEmpty: false)
        |> pivot(rowKey: ["_time"], columnKey: ["_field"], valueColumn: "_value")
        |> filter(fn: (r) => exists r.la and exists r.lo)
        |> limit(n: ${numPositions})
        |> sort(columns: ["_time"])`;

      console.log('GPS Query:', gpsQuery);

      const queryApi = new InfluxDB({url, token: this.getToken()}).getQueryApi(org);

      queryApi.queryRows(gpsQuery, {
        next(row, tableMeta) {
          const o = tableMeta.toObject(row);
          if (o.la && o.lo) {
            outerScope.gpsHistoricalPositions.push({
              lat: parseFloat(o.la),
              lng: parseFloat(o.lo),
              time: o._time
            });
          }
        },
        error(error) {
          console.error('GPS DATA FETCH ERROR', error);
          outerScope.isLoadingGpsData = false;
          outerScope.$notify({
            type: 'danger',
            message: outerScope.$t('commons.errorLoadingData') || 'Errore nel caricamento dei dati GPS',
            icon: 'tim-icons icon-alert-circle-exc',
          });
        },
        complete() {
          console.log('GPS DATA FETCH SUCCESS');
          console.log('Posizioni trovate:', outerScope.gpsHistoricalPositions.length);
          outerScope.isLoadingGpsData = false;

          if (outerScope.gpsHistoricalPositions.length > 0) {
            // Centra la mappa sull'ultima posizione trovata (che è l'ultima del time range)
            const lastPos = outerScope.gpsHistoricalPositions[outerScope.gpsHistoricalPositions.length - 1];
            outerScope.mapCenter = latLng(lastPos.lat, lastPos.lng);
            outerScope.currentCenter = latLng(lastPos.lat, lastPos.lng);
            outerScope.mapZoom = 15;
            outerScope.currentZoom = 15;

            outerScope.$notify({
              type: 'success',
              message: outerScope.$t('gps.showingHistoricalPositions'),
              icon: 'tim-icons icon-check-2',
            });
          } else {
            outerScope.$notify({
              type: 'warning',
              message: outerScope.$t('commons.noDataFound') || 'Nessuna posizione GPS trovata nel range selezionato',
              icon: 'tim-icons icon-alert-circle-exc',
            });
          }
        },
      });
    },
    // Map event handlers
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
  },
  mounted() {
    this.loadUser()
    this.toggleImages();
    // Refresh every 10 minutes
    var handler = setInterval(function () {
      //this.getBmsStatuses()
      this.getBmsData()
    }.bind(this), 10*60*1000)
    this.$store.commit('addTimerHandler', handler)
  }
};
</script>
<style>

/* Definizione dinamica della larghezza del bordo basata su viewport */
:root {
  --border-width: 4vw;
}

/* Limitazione massima del bordo a 75px */
@media (min-width: 1875px) {
  :root {
    --border-width: 75px;
  }
}

/* Limitazione minima del bordo a 8px per schermi molto piccoli */
@media (max-width: 200px) {
  :root {
    --border-width: 8px;
  }
}

.charged {
  border-left: var(--border-width) solid #2dce89;
}

.half-charged {
  border-left: var(--border-width) solid #fc8c42;
}

.not-charged {
  border-left: var(--border-width) solid #f5365c;
}

.disconnected {
  border-left: var(--border-width) solid #035afc;
}

/* Fallback aggiuntivo per browser molto vecchi */
.charged {
  border-left: 8px solid #2dce89; /* Fallback base */
  border-left: 4vw solid #2dce89; /* Dinamico con vw */
}

.half-charged {
  border-left: 8px solid #fc8c42; /* Fallback base */
  border-left: 4vw solid #fc8c42; /* Dinamico con vw */
}

.not-charged {
  border-left: 8px solid #f5365c; /* Fallback base */
  border-left: 4vw solid #f5365c; /* Dinamico con vw */
}

.disconnected {
  border-left: 8px solid #035afc; /* Fallback base */
  border-left: 4vw solid #035afc; /* Dinamico con vw */
}

/* Controllo del massimo tramite media query specifica */
@media (min-width: 1875px) {
  .charged {
    border-left: 75px solid #2dce89 !important;
  }

  .half-charged {
    border-left: 75px solid #fc8c42 !important;
  }

  .not-charged {
    border-left: 75px solid #f5365c !important;
  }

  .disconnected {
    border-left: 75px solid #035afc !important;
  }
}

.category, .card-category {
	text-transform: none;
}

/* Stile per modale GPS fullscreen */
.modal .gps-modal-fullscreen {
  max-width: 90vw !important;
  width: 90vw !important;
  height: 85vh !important;
  margin: 0 !important;
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  /* Disabilita le regole di modal-dialog-centered */
  display: block !important;
  align-items: unset !important;
  min-height: unset !important;
}

.modal .gps-modal-fullscreen::before {
  display: none !important;
}

.modal .gps-modal-fullscreen .modal-content {
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
}

.modal .gps-modal-fullscreen .modal-header {
  padding: 1% 1% 0 1% !important;
  border-bottom: none !important;
  flex-shrink: 0 !important;
}

.modal .gps-modal-fullscreen .modal-header .close {
  padding: 0 !important;
  margin: 0 !important;
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
}

.modal .gps-modal-fullscreen .modal-body {
  flex-grow: 1 !important;
  overflow: hidden !important;
  padding: 1% 1% 1% 1% !important;
  max-width: none !important;
  margin: 0 !important;
}

/* Stili per Leaflet map */
@import "~leaflet/dist/leaflet.css";

/* Stili per la row dei filtri date GPS */
.gps-filters-row {
  padding: 15px 20px;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.gps-date-input {
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 0;
}

.gps-date-button {
  padding-left: 5px;
  padding-right: 5px;
  display: flex;
  align-items: stretch;
  margin-bottom: 0;
}

.gps-date-button button {
  width: 100%;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding: 0.625rem 0.75rem !important;
  height: 38px !important;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Media query per schermi piccoli */
@media (max-width: 768px) {
  .gps-filters-row {
    padding: 10px 15px;
  }

  .gps-date-input {
    padding-left: 5px;
    padding-right: 5px;
    margin-bottom: 10px;
  }

  .gps-date-button {
    padding-left: 5px;
    padding-right: 5px;
    margin-top: 0;
    margin-bottom: 10px;
    padding-bottom: 0;
    align-items: stretch;
  }

  .gps-date-button button {
    height: auto;
  }
}

/* Fix z-index per i popover dei calendari nella modale GPS */
.gps-modal-fullscreen .vc-popover-content-wrapper {
  z-index: 10000 !important;
}

/* Stili per le icone personalizzate dei marker storici */
.custom-div-icon {
  background: transparent !important;
  border: none !important;
}

/* Assicurati che tutti i contenitori della mappa prendano tutto lo spazio */
.modal .gps-modal-fullscreen .modal-body > div {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}

/* Stili per Leaflet map */
@import "~leaflet/dist/leaflet.css";

/* Assicurati che la mappa riempia completamente il contenitore */
.leaflet-container {
  height: 100% !important;
  width: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* Stile specifico per la mappa all'interno della modale GPS */
.modal .gps-modal-fullscreen .vue2leaflet-map {
  width: 100% !important;
  height: 100% !important;
  max-width: none !important;
}

/* Stili responsive per le card BMS */
.bms-card-body {
  display: flex !important;
  align-items: stretch !important;
  padding: 15px !important;
  min-height: 140px;
  overflow: hidden;
}

.bms-content-wrapper {
  flex: 1;
  min-width: 0; /* Importante per permettere il shrinking del flex item */
  margin-right: 10px;
}

.bms-text-section {
  padding: 5px;
  overflow: hidden;
}

.bms-text-section .card-text,
.bms-text-section .card-category {
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  line-height: 1.2;
}

/* Controllo dell'interruzione di riga specifico per il campo "ultima misurazione" */
.last-seen-text {
  /* Impedisce l'interruzione tra cifre consecutive */
  word-break: keep-all;
  /* Disabilita i trattini automatici */
  hyphens: none;
  /* Permette l'interruzione solo sui tag <wbr> inseriti */
  overflow-wrap: normal;
  /* Mantiene il layout normale */
  white-space: normal;
}

.bms-title {
  font-size: calc(1.2rem + 0.5vw) !important;
  max-width: 100%;
}

.bms-gps-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 70px;
  min-width: 70px;
}

.gps-btn {
  background: none;
  border: none;
  padding: 12px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.gps-btn:hover {
  background-color: rgba(0, 123, 255, 0.1);
  transform: scale(1.1);
}

.gps-btn-disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.gps-btn-disabled:hover {
  background-color: transparent;
  transform: none;
}

.gps-btn i {
  font-size: clamp(28px, 6vw, 36px);
  color: #007bff;
}

.gps-label {
  color: #007bff;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 2px;
  line-height: 1;
}

/* Media queries per schermi molto piccoli */
@media (max-width: 768px) {
  .bms-card-body {
    padding: 10px !important;
    min-height: 120px;
  }

  .bms-content-wrapper {
    margin-right: 5px;
  }

  .bms-gps-button {
    width: 55px;
    min-width: 55px;
  }

  .gps-label {
    font-size: 11px;
    margin-top: 1px;
  }

  .bms-text-section {
    padding: 3px;
  }

  .bms-text-section .card-text {
    font-size: 0.9rem !important;
  }

  .bms-title {
    font-size: 1rem !important;
  }
}

@media (max-width: 576px) {
  .bms-card-body {
    padding: 8px !important;
    min-height: 100px;
  }

  .bms-gps-button {
    width: 50px;
    min-width: 50px;
  }

  .gps-btn {
    padding: 8px;
  }

  .gps-label {
    font-size: 10px;
    margin-top: 0;
  }

  .bms-text-section .card-text {
    font-size: 0.8rem !important;
    line-height: 1.1;
  }

  .bms-text-section .card-category {
    font-size: 0.7rem !important;
  }
}


</style>
